// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';

// Afidium
import { ConditionsTabComponent } from './conditions-tab.component';
import { ConditionsTabService } from "./conditions-tab.service";
import { SectorsAirSimpleListModule } from 'libraries/component/sectors-air-simple-list/sectors-air-simple-list.module';
import { TravellerDataTranslationModule } from 'libraries/service/traveller-data-translation/traveller-data-translation.module';
import { SectorTravellerModule } from '../../../sectors/components/shared/components/sector-traveller/sector-traveller.module';
import { SectorsAirSummaryWithRuptureModule } from '../sectors-air-summary-with-rupture/sectors-air-summary-with-rupture.module';
import { CancellationConditionsModule } from 'libraries/hotel/components/cancellation-conditions/cancellation-conditions.module';
import { TableSectorAirSummaryModule } from '../shared/components/table-sector-air-summary/table-sector-air-summary.module';
import { DateValidityModule } from './components/date-validity/date-validity.module';
import { LuggageModule } from 'libraries/luggage/luggage.module';
import { ExchangeModule } from './components/exchange/exchange.module';
import { StaySummaryModule } from '../../../sectors/components/sectors-stay/stay-summary/stay-summary.module';
import { TableSectorStaySummaryModule } from '../shared/components/table-sector-stay-summary/table-sector-stay-summary.module';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";

@NgModule({
    imports: [
        CommonModule,
        MatTableModule,
        SectorsAirSimpleListModule,
        SectorsAirSummaryWithRuptureModule,
        TravellerDataTranslationModule,
        SectorTravellerModule,
        CancellationConditionsModule,
        TableSectorAirSummaryModule,
        DateValidityModule,
        LuggageModule,
        StaySummaryModule,
        ExchangeModule,
        TableSectorStaySummaryModule,
        FontAwesomeModule,
    ],
    exports: [ConditionsTabComponent],
    declarations: [ConditionsTabComponent],
    providers: [
        ConditionsTabService,
    ]
})
export class ConditionsTabModule { }
